<template>
  <div class="animated fadeIn">
    <div class="container">
      <h2 class="title">綠能公車亭智慧照明應用</h2>

      <!-- 太陽 (發電) -->
      <div class="item-center">
        <img src="/img/innoknight/sun.png" class="icon-small" />
        <p class="power-text">{{Power_Sun}}瓦</p>
      </div>

      <!-- 中間部分 -->
      <div class="middle-container">
        <!-- 電池 -->
        <div class="item-center">
          <p class="health-text">健康{{SOH}}%</p>
          <img src="/img/innoknight/car-battery.png" class="icon-small" />
          <p class="battery-text">電量{{SOC}}%</p>
        </div>

        <!-- 電池 -> 公車站 -->
        <div class="item-center">
          <div class="power-text">{{Power_Battery_In}}瓦</div>
          <div v-if="is_right" class="energy-arrow-container">
            <span  class="arrow-right">▶</span >
            <span  class="arrow-right">▶</span >
            <span  class="arrow-right">▶</span >
            <span  class="arrow-right">▶</span >
            <span  class="arrow-right">▶</span >
            <span  class="arrow-right">▶</span >
          </div>
          <div v-else class="energy-arrow-container">
            <span  class="arrow-left">◀</span >
            <span  class="arrow-left">◀</span >
            <span  class="arrow-left">◀</span >
            <span  class="arrow-left">◀</span >
            <span  class="arrow-left">◀</span >
            <span  class="arrow-left">◀</span >
          </div>
        </div>

        <!-- 公車站 -->
        <div class="item-center">
          <img src="/img/innoknight/bus-stop.png" class="icon-large" />
        </div>

        <!-- 公車站 -> LED燈 -->
        <div class="item-center">
          <div class="power-text">{{Power_Led}}瓦</div>
          <div class="energy-arrow-container">
            <span  class="arrow-right">▶</span >
            <span  class="arrow-right">▶</span >
            <span  class="arrow-right">▶</span >
            <span  class="arrow-right">▶</span >
            <span  class="arrow-right">▶</span >
            <span  class="arrow-right">▶</span >
          </div>
        </div>

        <!-- LED燈 -->
        <div class="item-center">
          <img src="/img/innoknight/led-light.png" class="icon-small" />
          <p class="led-text">LED</p>
        </div>
      </div>

      <div class="justify-content-center text-white mt-1">
        儲能更新時間: {{DeviceUpdateTime}}
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config/global'
import io from 'socket.io-client'

//let $socket  = null;

export default {
  name: 'dashboard',
  data() {
    return {
      socket: null,
      is_right: false,
      Power_Sun: 0,
      Power_Battery_In: 0,
      Power_Led: 0,
      SOH: 0,
      SOC: 0,
      SensroUpdateTime: '未知',
      DeviceUpdateTime: '未知',
      refresh_interval: 60000,//60sec
      refresh_time: null,
    }
  },
  mounted(){
    let app = this;
    //this.RefreshTimer();

    this.socket = io(config.socket_entry, {
      upgrade: true,
      rememberUpgrade: true,
      forceNode: true,
    });

    // console.info('config.socket_entry:', config.socket_entry);
    
    this.socket.on('connect', () => {
      console.log('Socket 已連線');
      this.ReadPower();
    });

    this.socket.on('disconnect', () => {
      console.log('Socket 已斷線');
    });

    this.socket.on('update', (data) => {
      //console.info('update:', data);
      if(data.success){
        this.Refresh(data.device);
      }
    });
  },
  beforeDestroy(){
		if(this.refresh_time) {
			clearTimeout(this.refresh_time);
		}
    if (this.socket) {
      this.socket.disconnect(); // 斷開連線
      this.socket = null; // 清空引用，確保 GC 回收
      console.log('Socket 已釋放');
    }
	},
  methods: {
    Refresh(device){
      if(device){
        let PV1_Input_Power = device.Inverter.PV1_Input_Power;
        let PV2_Input_Power = device.Inverter.PV2_Input_Power;
        let AC_Output_Active_Power = device.Inverter.AC_Output_Active_Power;
        let AC_Output_Rating_Active_Power = device.Inverter.AC_Output_Rating_Active_Power;
        let SOC = device.Pack.SOC;
        let SOH = device.Pack.SOH;
        this.DeviceUpdateTime = device.UpdateTime ? device.UpdateTime : '未知';

        this.Power_Sun = PV1_Input_Power + PV2_Input_Power;
        this.Power_Led = AC_Output_Active_Power;
        this.Power_Battery_In = this.Power_Sun - this.Power_Led;
        if(this.Power_Battery_In <= 0) {
          this.is_right = true;
          this.Power_Battery_In = Math.abs(this.Power_Battery_In);
        } else {
          this.is_right = false;
        }

        this.SOH = SOH;
        this.SOC = SOC;
      }
    },
    ReadPower() {
      this.$jsonp(`${config.api_root}/ReadPower`, {
        sn: encodeURIComponent(config.encrypt('ECO04-0001', config.ffkey, config.ffiv)),
        user_id: encodeURIComponent(3),
      }, 5000).then((result) => {
        //console.info('result:', result);
        if(result.success){
          this.Refresh(result.device);
        }
      });
    },
    RefreshTimer(){ //No used now
      //let app = this;
      if(this.refresh_time) {
        clearTimeout(this.refresh_time);
        this.refresh_time = null;
      }

      this.$jsonp(`${config.api_root}/ReadPower`, {
        sn: encodeURIComponent(config.encrypt('ECO04-0001', config.ffkey, config.ffiv)),
        user_id: encodeURIComponent(3),
      }, 5000).then((result) => {
        //console.info('result:', result);
        if(result.success){
          this.Refresh(result.device);
        }
      });

      this.refresh_time = setTimeout(() => {
        this.RefreshTimer();
      }, this.refresh_interval);
    }
  }
}
</script>

<style>
/* 全局容器 */
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;  /* 讓 `.container` 佔滿父層 */
  max-width: 100vw;
  height: 80vh;
  background-color: black;
  position: relative;
}

/* 標題樣式 */
.title {
  font-size: 28px; /* 放大標題 */
  font-weight: bold;
  margin-bottom: 10px;
  color: #fff;
}

/* 能量流動區域 */
.middle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0px;
  width: 100%; /* 讓容器寬度隨父元素大小變化 */
  flex-grow: 1; /* 讓其填滿可用空間 */
}

.energy-arrow-container {
  display: flex;
  gap: 10px;
}

/* 置中對齊 */
.item-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* 確保垂直和水平都置中 */
  flex: 1; /* 讓元素填滿可用空間 */
  min-width: 100px;
}

/* 圖片大小 */
.icon-small {
  width: 128px;
  height: 128px;
}

.icon-large {
  width: 256px;
  height: 256px;
}

/* 電池資訊 */
.battery-text {
  font-size: 36px;
  color: white;
  margin-top: 5px;
}

.health-text {
  font-size: 36px;
  color: #00ff00; /* 綠色字體 */
  margin-top: 0px;
}

/* 文字樣式 */
.power-text {
  font-size: 36px;
  color: white;
  font-weight: bold;
  margin: 0 10px;
}

.led-text {
  font-size: 36px;
  color: white;
  margin-top: 5px;
}

.arrow-right {
  font-size: 24px;
  color: #2ecc71;
  opacity: 0;
  animation: energy-flow-right 1.5s infinite linear;
}

.arrow-left {
  font-size: 24px;
  color: #2ecc71;
  opacity: 0;
  animation: energy-flow-left 1.5s infinite linear;
}

.arrow-right:nth-child(1) { animation-delay: 0s; }
.arrow-right:nth-child(2) { animation-delay: 0.2s; }
.arrow-right:nth-child(3) { animation-delay: 0.4s; }
.arrow-right:nth-child(4) { animation-delay: 0.6s; }
.arrow-right:nth-child(5) { animation-delay: 0.8s; }
.arrow-right:nth-child(6) { animation-delay: 1.0s; }

.arrow-left:nth-child(1) { animation-delay: 1.0s; }
.arrow-left:nth-child(2) { animation-delay: 0.7s; }
.arrow-left:nth-child(3) { animation-delay: 0.6s; }
.arrow-left:nth-child(4) { animation-delay: 0.4s; }
.arrow-left:nth-child(5) { animation-delay: 0.2s; }
.arrow-left:nth-child(6) { animation-delay: 0s; }

@keyframes energy-flow-right {
  0% { opacity: 0; transform: translateX(0); }
  50% { opacity: 1; transform: translateX(10px); }
  100% { opacity: 0; transform: translateX(20px); }
}

@keyframes energy-flow-left {
  0% { opacity: 0; transform: translateX(0); }
  50% { opacity: 1; transform: translateX(-10px); }
  100% { opacity: 0; transform: translateX(-20px); }
}
</style>
